import React from 'react';

export interface RippleLoaderProps {
    loaderClass?: string
    text?: string
}

const RippleLoader: React.FunctionComponent<RippleLoaderProps> = (props) => {
    const className = "loader-container loader-ripple " + props.loaderClass
    return (
        <div className={className}>
            <div className="lds-ripple">
                <div className="lds-circle"></div>
                <div className="lds-circle"></div>
            </div>
            <div className="lds-text">
                <p>{props.text}</p>
            </div>
        </div>
    )
}

export default RippleLoader;